import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { APP_BASENAME } from './appPaths';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <BrowserRouter basename={APP_BASENAME}>
    <App />
  </BrowserRouter>,
);
